import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Rules from './pages/Rules';
import NotFound from './pages/NotFound';
import Navbar from './components/Navbar';
import HomeBackButton from '../../components/HomeBackButton';
import bgImage from './background.jpg';
import './HungerGamesApp.css';

export default function HungerGamesApp() {
  return (
    <div
      className="app-hunger-games"
      style={{ ['--hg-bg' as any]: `url(${bgImage})` }}
    >
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <HomeBackButton variant="dark" />
    </div>
  );
}
